import React, { lazy, Suspense, useContext } from 'react';
import Loader from '../layout/Loader';
import Prefix from '../../pages/Basicorderinformation/prefix';
import DashboardContext from '../../Context';
import Contact from '../../pages/userprofiles/contact';
import PartnerCompany from '../../pages/Vendors/PartnerCompany';
import Worker from '../../pages/forces/worker';
import BusinessCompany from '../../pages/forces/BusinessCompany';
import B2BAddress from 'pages/forces/B2BAddress';
import B2BUser from 'pages/forces/B2BUser';
import Warranty from '../../pages/financialdepartment/warranty';
import WorkerVip from '../../pages/forces/workerVip';
import CategoryQuestion from '../../pages/BasicInformation/categoryQuestion';
import AppDiscount from '../../pages/BasicInformation/appDiscount';
import Advertisement from '../../pages/BasicInformation/advertisement';
import ConsultationRequest from '../../pages/ConsultationRequest/index';
import OrderFacility from '../../pages/Basicorderinformation/orderFacility';
import CustomerReport from '../../pages/report/customerReport';
import CustomerFinancialReport from '../../pages/report/Financial/customerFinancialReport';
import WorkerFinancialReport from '../../pages/report/Financial/workerFinancialReport';
import OrderReport from '../../pages/report/orderReport';
import DiscountCouponReport from '../../pages/report/discountCouponReport';
import InsuranceReport from '../../pages/report/insuranceReport';
import NewCustomersReport from '../../pages/report/newCustomersReport';
import JobDispatchActionReport from '../../pages/report/jobDispatchActionReport';
import WorkCancelReport from 'pages/report/workCancelReport';
import BusinessToBusinessNotification from '../../pages/businessToBusinessNotification';
// import AdvertisingSource from "../../pages/BasicInformation/marketing/advertisingSource";
const Leave = lazy(() => import('../../pages/forces/leave'));
const WorkerDocument = lazy(() => import('../../pages/forces/workerDocument'));
const Supplier = lazy(() => import('../../pages/Vendors/supplier'));
const Ticket = lazy(() => import('../../pages/userprofiles/ticket'));
const BusinessToBusinessTicket = lazy(() =>
  import('../../pages/BusinessToBusinessTicket')
);
const GroupQuestion = lazy(() => import('../../pages/mojenoWeb/groupQuestion'));
const UserManagement = lazy(() =>
  import('../../pages/userprofiles/userManagement')
);
const GroupGallery = lazy(() => import('../../pages/mojenoWeb/groupGallery'));
const WorkerCommissionDiscount = lazy(() =>
  import('../../pages/forces/workerCommissionDiscount')
);
const WorkerOrderSchedule = lazy(() =>
  import('../../pages/forces/workerOrderSchedule')
);
const Order = lazy(() => import('../../pages/Order/Order'));
const CanceledOrder = lazy(() => import('../../pages/Order/CanceledOrder'));
const OnlineCanceledOrder = lazy(() =>
  import('../../pages/Order/OnlineCanceledOrder')
);
const BusinessToBusinessOrder = lazy(() =>
  import('../../pages/Order/BusinessToBusinessOrder')
);
const OnlineOrder = lazy(() => import('../../pages/Order/OnlineOrder'));
const B2BOnlineOrder = lazy(() => import('../../pages/Order/B2BOnlineOrder'));
const Roles = lazy(() => import('../../pages/Useraccess/Roles'));
const WorkerWallet = lazy(() =>
  import('../../pages/financialdepartment/workerWallet')
);
const PaymentReceipt = lazy(() =>
  import('../../pages/financialdepartment/PaymentReceipt')
);
const CustomerWallet = lazy(() =>
  import('../../pages/financialdepartment/CustomerWallet')
);
const WorkerMessage = lazy(() => import('../../pages/forces/WorkerMessage'));
const CustomerMessage = lazy(() =>
  import('../../pages/forces/CustomerMessage')
);
const PeriodOrder = lazy(() => import('../../pages/Order/PeriodOrder'));
const BusinessToBusinessPeriodOrder = lazy(() =>
  import('../../pages/Order/BusinessToBusinessPeriodOrder')
);
const CustomerIndex = lazy(() =>
  import('../../pages/userprofiles/Custoumer/CustomerIndex')
);
const Address = lazy(() => import('../../pages/userprofiles/Address'));
const EmploymentReport = lazy(() =>
  import('../../pages/forces/employmentReport')
);
const AccountBalance = lazy(() =>
  import('../../pages/financialdepartment/AccountBalance')
);
const Setting = lazy(() => import('../../pages/BasicInformation/setting'));
const SmsLog = lazy(() => import('../../pages/messages/smsLog/Index'));
const Personposition = lazy(() =>
  import('../../pages/BasicInformation/personposition')
);
const PaymentInformation = lazy(() =>
  import('../../pages/financialdepartment/paymentInformation')
);
const DebtTracking = lazy(() =>
  import('../../pages/financialdepartment/debtTracking')
);
const ApplicationGallery = lazy(() =>
  import('../../pages/BasicInformation/applicationGallery')
);
const Contracttime = lazy(() =>
  import('../../pages/Basicorderinformation/contracttime')
);
const GroupOption = lazy(() =>
  import('../../pages/Basicorderinformation/groupOption')
);
const WorkCancelPolicy = lazy(() =>
  import('../../pages/Basicorderinformation/workCancelPolicy')
);
const Instruction = lazy(() =>
  import('../../pages/Basicorderinformation/instruction')
);
const Pet = lazy(() => import('../../pages/Basicorderinformation/pet'));
const Placetype = lazy(() =>
  import('../../pages/Basicorderinformation/placetype')
);
const DiscountCoupon = lazy(() =>
  import('../../pages/discount/discountCoupon')
);
const GroupDiscount = lazy(() => import('../../pages/discount/groupDiscount'));
const GroupOptionDiscount = lazy(() =>
  import('../../pages/discount/groupOptionDiscount')
);
const GroupOptionTitle = lazy(() =>
  import('../../pages/Basicorderinformation/groupOptionTitle')
);
const SupportType = lazy(() =>
  import('../../pages/BasicInformation/supportType')
);
const Specification = lazy(() =>
  import('../../pages/Basicinformationoftheforces/specification')
);
const SpecificationTitle = lazy(() =>
  import('../../pages/Basicinformationoftheforces/specificationTitle')
);
const SpecificationValue = lazy(() =>
  import('../../pages/Basicinformationoftheforces/specificationValue')
);
const SurveyTitle = lazy(() =>
  import('../../pages/Basicinformationoftheforces/surveyTitle')
);
const Category = lazy(() => import('../../pages/BasicInformation/category'));
const Banner = lazy(() =>
  import('../../pages/Basicapplicationinformation/banner')
);
const ExpertPostCategory = lazy(() =>
  import('../../pages/Basicapplicationinformation/expertPostCategory')
);
const ExpertPost = lazy(() =>
  import('../../pages/Basicapplicationinformation/expertPost')
);
const ExpertStory = lazy(() =>
  import('../../pages/Basicapplicationinformation/expertStory')
);
const WorkActionReason = lazy(() =>
  import('../../pages/Basicorderinformation/workActionReason')
);
const Group = lazy(() => import('../../pages/BasicInformation/group'));
const AdvertisingSource = lazy(() =>
  import('../../pages/BasicHumanResources/advertisingSource')
);
const District = lazy(() => import('../../pages/BasicInformation/District'));
const City = lazy(() => import('../../pages/BasicInformation/city'));
const Referrer = lazy(() => import('../../pages/BasicInformation/referrer'));
const Discipline = lazy(() =>
  import('../../pages/BasicInformation/discipline')
);
const Dorm = lazy(() => import('../../pages/BasicInformation/dorm'));
const WorkEquipment = lazy(() =>
  import('../../pages/BasicHumanResources/workEquipment')
);
const InterviewSchedule = lazy(() =>
  import('../../pages/BasicHumanResources/interviewSchedule')
);
const ExpertBaseReason = lazy(() =>
  import('../../pages/BasicHumanResources/ExpertBaseReason')
);

// financial
const AdvancePaymentPolicy = lazy(() =>
  import('pages/financialdepartment/advancePaymentPolicy')
);
const AdvancePayment = lazy(() =>
  import('pages/financialdepartment/advancePayment')
);
const ReceivableReceipt = lazy(() =>
  import('pages/financialdepartment/receivableReceipt')
);
const WorkerCalculationMonthlySalary = lazy(() =>
  import('pages/financialdepartment/workerCalculationMonthlySalary')
);
const WorkerMonthlySalary = lazy(() =>
  import('pages/financialdepartment/workerMonthlySalary')
);
const AdvancePaymentBlockWorker = lazy(() =>
  import('pages/financialdepartment/advancePaymentBlockWorker')
);
const InsuranceRule = lazy(() =>
  import('pages/financialdepartment/insuranceRule')
);
const InsurancePremium = lazy(() =>
  import('pages/financialdepartment/insurancePremium')
);
const InsurancePremiumReport = lazy(() =>
  import('pages/financialdepartment/insurancePremiumReport')
);

// b2b customer
const KarlineCustomerProfile = lazy(() =>
  import('pages/userprofiles/KarlineCustomerProfile/CustomerIndex')
);

// missions
const SurveyMission = lazy(() => import('pages/missions/surveyMission'));
const AlternativeWorkerMission = lazy(() =>
  import('pages/missions/alternativeWorkerMission')
);
const FavoriteWorkerMission = lazy(() =>
  import('pages/missions/favoriteWorkerMission')
);
const IntroductionCustomerMission = lazy(() =>
  import('pages/missions/introductionCustomerMission')
);
const WorkCompletedMission = lazy(() =>
  import('pages/missions/workCompletedMission')
);
const IntroductionWorkerMission = lazy(() =>
  import('pages/missions/introductionWorkerMission')
);
const SpecialDaysMission = lazy(() =>
  import('pages/missions/specialDaysMission')
);
const SpecialOrderMission = lazy(() =>
  import('pages/missions/specialOrderMission')
);
const PointMission = lazy(() => import('pages/missions/pointMission'));
const RewardMission = lazy(() => import('pages/missions/rewardMission'));
const NDaysAfterStartMission = lazy(() =>
  import('pages/missions/nDaysAfterStartMission')
);

// reports
const OrderFacilityReport = lazy(() =>
  import('pages/report/orderFacilityReport')
);
const ExpertContentLikeReport = lazy(() =>
  import('pages/report/expertContentLikeReport')
);
const ExpertContentViewReport = lazy(() =>
  import('pages/report/expertContentViewReport')
);
const ContractualOrderScheduleReport = lazy(() =>
  import('pages/report/contractualOrderScheduleReport')
);
const ContractualOrderScheduleRenewalReport = lazy(() =>
  import('pages/report/contractualOrderScheduleRenewalReport')
);
const ContractualOrderScheduleSaleFunnelStatusHistoryReport = lazy(() =>
  import('pages/report/contractualOrderScheduleSaleFunnelStatusHistoryReport')
);
const OrderPerformanceReport = lazy(() =>
  import('pages/report/orderPerformanceReport')
);
const MarketingWorkerIntroducedReport = lazy(() =>
  import('pages/report/marketingWorkerIntroducedReport')
);

// mission reports
const WorkCompletedMissionReport = lazy(() =>
  import('pages/report/missions/workCompletedMissionReport')
);
const CustomerIntroductionMissionReport = lazy(() =>
  import('pages/report/missions/customerIntroductionMissionReport')
);
const PointMissionReport = lazy(() =>
  import('pages/report/missions/pointMissionReport')
);
const SurveyMissionReport = lazy(() =>
  import('pages/report/missions/surveyMissionReport')
);
const WorkerIntroductionMissionReport = lazy(() =>
  import('pages/report/missions/workerIntroductionMissionReport')
);
const FavoriteWorkerMissionReport = lazy(() =>
  import('pages/report/missions/favoriteWorkerMissionReport')
);
const NDaysAfterStartMissionReport = lazy(() =>
  import('pages/report/missions/nDaysAfterStartMissionReport')
);
const RewardMissionReport = lazy(() =>
  import('pages/report/missions/rewardMissionReport')
);
const SpecialDaysMissionReport = lazy(() =>
  import('pages/report/missions/specialDaysMissionReport')
);
const SpecialOrderMissionReport = lazy(() =>
  import('pages/report/missions/specialOrderMissionReport')
);

// baseInfo
const WorkerSelectionAssistant = lazy(() =>
  import('pages/BasicInformation/workerSelectionAssistant')
);
const TimePrivacy = lazy(() => import('pages/BasicInformation/timePrivacy'));
const ServicePoint = lazy(() => import('pages/BasicInformation/servicePoint'));
const TransportationProvider = lazy(() =>
  import('pages/BasicInformation/transportationProvider')
);

// ticketing
const ExpertTicket = lazy(() => import('pages/forces/expertTicket'));

// contractual base info
const Obligation = lazy(() =>
  import('pages/BasicContractualInformation/obligation')
);
const ContractualOrderOperationReason = lazy(() =>
  import('pages/BasicContractualInformation/contractualOrderOperationReason')
);
const SaleFunnelStepActivity = lazy(() =>
  import('pages/BasicContractualInformation/saleFunnelStepActivity')
);
const Contract = lazy(() =>
  import('pages/BasicContractualInformation/contract')
);
const ContractOffer = lazy(() =>
  import('pages/BasicContractualInformation/contractOffer')
);

// contractual orders
const ContractualOrderSchedule = lazy(() =>
  import('pages/Order/contractual/contractualOrderSchedule')
);
const ContractualOrderLead = lazy(() =>
  import('pages/Order/contractual/contractualOrderLead')
);
const ContractualOrderScheduleSaleLead = lazy(() =>
  import('pages/Order/contractual/contractualOrderScheduleSaleLead')
);
const ContractualOrderScheduleCanceled = lazy(() =>
  import('pages/Order/contractual/contractualOrderScheduleCanceled')
);
const ContractualOrderScheduleSaleOpportunity = lazy(() =>
  import('pages/Order/contractual/contractualOrderScheduleSaleOpportunity')
);
const ContractualOrderScheduleSaleOpportunitySuccessful = lazy(() =>
  import(
    'pages/Order/contractual/contractualOrderScheduleSaleOpportunitySuccessful'
  )
);

// monitoring
const TransportationMonitoring = lazy(() =>
  import('pages/monitoring/transportationMonitoring')
);
const Snapp = lazy(() => import('pages/monitoring/snapp'));

// messages
const MessageInApplication = lazy(() =>
  import('pages/messages/messageInApplication')
);

// messages
const JobDispatch = lazy(() => import('pages/monitoring/jobDispatch'));

// جداسازی
const CardToCardTracking = lazy(() =>
  import('pages/financialdepartment/cardToCardTracking')
);

/**
 * این کامپوننت تعریف  ادرس ها به عهد دارد و بر اساس مپ انجام شده تغییر می کند
 */

export default function ComponetMinger(props) {
  const { urlPatch } = useContext(DashboardContext);

  let routeComponent = 'please add component to ComponetMinger';

  switch (urlPatch) {
    case '/Leave':
      routeComponent = <Leave />;
      break;
    case '/Prefix':
      routeComponent = <Prefix />;
      break;
    case '/City':
      routeComponent = <City />;
      break;
    case '/BusinessCompany':
      routeComponent = <BusinessCompany />;
      break;
    case '/Referrer':
      routeComponent = <Referrer />;
      break;
    case '/Discipline':
      routeComponent = <Discipline />;
      break;
    case '/Dorm':
      routeComponent = <Dorm />;
      break;
    case '/PersonPosition':
      routeComponent = <Personposition />;
      break;
    case '/District':
      routeComponent = <District />;
      break;
    case '/Group':
      routeComponent = <Group />;
      break;
    case '/BusinessToBusinessNotification':
      routeComponent = <BusinessToBusinessNotification />;
      break;
    case '/DebtTracking':
      routeComponent = <DebtTracking />;
      break;

    case '/PaymentInformation':
      routeComponent = <PaymentInformation />;
      break;
    case '/ApplicationGallery':
      routeComponent = <ApplicationGallery />;
      break;
    case '/Category':
      routeComponent = <Category />;
      break;
    case '/Banner':
      routeComponent = <Banner />;
      break;
    case '/ExpertPostCategory':
      routeComponent = <ExpertPostCategory />;
      break;
    case '/ExpertPost':
      routeComponent = <ExpertPost />;
      break;
    case '/ExpertStory':
      routeComponent = <ExpertStory />;
      break;
    case '/InterviewSchedule':
      routeComponent = <InterviewSchedule />;
      break;
    case '/WorkActionReason':
      routeComponent = <WorkActionReason />;
      break;
    case '/ContractTime':
      routeComponent = <Contracttime />;
      break;
    case '/GroupOption':
      routeComponent = <GroupOption />;
      break;
    case '/WorkCancelPolicy':
      routeComponent = <WorkCancelPolicy />;
      break;
    case '/Instruction':
      routeComponent = <Instruction />;
      break;
    case '/PlaceType':
      routeComponent = <Placetype />;
      break;
    case '/Pet':
      routeComponent = <Pet />;
      break;

    case '/DiscountCoupon':
      routeComponent = <DiscountCoupon />;
      break;
    case '/GroupDiscount':
      routeComponent = <GroupDiscount />;
      break;
    case '/GroupOptionDiscount':
      routeComponent = <GroupOptionDiscount />;
      break;

    case '/GroupOptionTitle':
      routeComponent = <GroupOptionTitle />;
      break;
    case '/Contact':
      routeComponent = <Contact />;
      break;

    case '/SupportType':
      routeComponent = <SupportType />;
      break;
    case '/Specification':
      routeComponent = <Specification />;
      break;
    case '/SpecificationTitle':
      routeComponent = <SpecificationTitle />;
      break;
    case '/SpecificationValue':
      routeComponent = <SpecificationValue />;
      break;
    case '/SurveyTitle':
      routeComponent = <SurveyTitle />;
      break;
    case '/PartnerCompany':
      routeComponent = <PartnerCompany />;
      break;
    case '/Worker':
      routeComponent = <Worker />;
      break;
    case '/B2BAddress':
      routeComponent = <B2BAddress />;
      break;
    case '/B2BUser':
      routeComponent = <B2BUser />;
      break;
    case '/WorkerDocument':
      routeComponent = <WorkerDocument />;
      break;
    case '/Supplier':
      routeComponent = <Supplier />;
      break;
    case '/Ticket':
      routeComponent = <Ticket />;
      break;
    case '/BusinessToBusinessTicket':
      routeComponent = <BusinessToBusinessTicket />;
      break;
    case '/GroupQuestion':
      routeComponent = <GroupQuestion />;
      break;
    case '/UserManagement':
      routeComponent = <UserManagement />;
      break;

    case '/GroupGallery':
      routeComponent = <GroupGallery />;
      break;
    case '/WorkerCommissionDiscount':
      routeComponent = <WorkerCommissionDiscount />;
      break;
    case '/WorkerOrderSchedule':
      routeComponent = <WorkerOrderSchedule />;
      break;
    case '/CanceledOrder':
      routeComponent = <CanceledOrder />;
      break;

    case '/BusinessToBusinessCanceledOrder':
      routeComponent = <OnlineCanceledOrder />;
      break;
    case '/BusinessToBusinessOrder':
      routeComponent = <BusinessToBusinessOrder />;
      break;
    case '/BusinessToBusinessOnlineOrder':
      routeComponent = <B2BOnlineOrder />;
      break;
    case '/OnlineOrder':
      routeComponent = <OnlineOrder />;
      break;
    case '/Roles':
      routeComponent = <Roles />;
      break;
    case '/Order':
      routeComponent = <Order />;
      break;
    case '/AdvertisingSource':
      routeComponent = <AdvertisingSource />;
      break;
    case '/WorkerWallet':
      routeComponent = <WorkerWallet />;
      break;
    case '/PaymentReceipt':
      routeComponent = <PaymentReceipt />;
      break;
    case '/CustomerWallet':
      routeComponent = <CustomerWallet />;
      break;
    case '/WorkerMessage':
      routeComponent = <WorkerMessage />;
      break;
    case '/CustomerMessage':
      routeComponent = <CustomerMessage />;
      break;
    case '/PeriodOrder':
      routeComponent = <PeriodOrder />;
      break;
    case '/BusinessToBusinessPeriodOrder':
      routeComponent = <BusinessToBusinessPeriodOrder />;
      break;
    case '/Customer':
      routeComponent = <CustomerIndex />;
      break;
    case '/Address':
      routeComponent = <Address />;
      break;
    case '/EmploymentReport':
      routeComponent = <EmploymentReport />;
      break;
    case '/AccountBalance':
      routeComponent = <AccountBalance />;
      break;
    case '/Setting':
      routeComponent = <Setting />;
      break;
    case '/SmsLog':
      routeComponent = <SmsLog />;
      break;
    case '/Warranty':
      routeComponent = <Warranty />;
      break;
    case '/WorkerVip':
      routeComponent = <WorkerVip />;
      break;
    case '/CategoryQuestion':
      routeComponent = <CategoryQuestion />;
      break;
    case '/ExpertBaseReason':
      routeComponent = <ExpertBaseReason />;
      break;
    case '/OrderFacility':
      routeComponent = <OrderFacility />;
      break;
    case '/AppDiscount':
      routeComponent = <AppDiscount />;
      break;
    case '/Advertisement':
      routeComponent = <Advertisement />;
      break;
    case '/ConsultationRequest':
      routeComponent = <ConsultationRequest />;
      break;
    case '/CustomerReport':
      routeComponent = <CustomerReport />;
      break;
    case '/CustomerFinancialReport':
      routeComponent = <CustomerFinancialReport />;
      break;
    case '/WorkerFinancialReport':
      routeComponent = <WorkerFinancialReport />;
      break;
    case '/WorkEquipment':
      routeComponent = <WorkEquipment />;
      break;
    case '/OrderReport':
      routeComponent = <OrderReport />;
      break;
    case '/DiscountCouponReport':
      routeComponent = <DiscountCouponReport />;
      break;
    case '/WorkerInsuranceReport':
      routeComponent = <InsuranceReport />;
      break;
    case '/NewCustomerReport':
      routeComponent = <NewCustomersReport />;
      break;
    case '/JobDispatchActionReport':
      routeComponent = <JobDispatchActionReport />;
      break;
    case '/WorkCancelReport':
      routeComponent = <WorkCancelReport />;
      break;
    case '/SurveyMission':
      routeComponent = <SurveyMission />;
      break;
    case '/AlternativeWorkerMission':
      routeComponent = <AlternativeWorkerMission />;
      break;
    case '/FavoriteWorkerMission':
      routeComponent = <FavoriteWorkerMission />;
      break;
    case '/IntroductionCustomerMission':
      routeComponent = <IntroductionCustomerMission />;
      break;
    case '/WorkCompletedMission':
      routeComponent = <WorkCompletedMission />;
      break;
    case '/KarlineCustomerProfile':
      routeComponent = <KarlineCustomerProfile />;
      break;
    case '/IntroductionWorkerMission':
      routeComponent = <IntroductionWorkerMission />;
      break;
    case '/AdvancePaymentPolicy':
      routeComponent = <AdvancePaymentPolicy />;
      break;
    case '/AdvancePayment':
      routeComponent = <AdvancePayment />;
      break;
    case '/SpecialDaysMission':
      routeComponent = <SpecialDaysMission />;
      break;
    case '/SpecialOrderMission':
      routeComponent = <SpecialOrderMission />;
      break;
    case '/PointMission':
      routeComponent = <PointMission />;
      break;
    case '/ReceivableReceipt':
      routeComponent = <ReceivableReceipt />;
      break;
    case '/RewardMission':
      routeComponent = <RewardMission />;
      break;
    case '/OrderFacilityReport':
      routeComponent = <OrderFacilityReport />;
      break;
    case '/NDaysAfterStartMission':
      routeComponent = <NDaysAfterStartMission />;
      break;
    case '/WorkerCalculationMonthlySalary':
      routeComponent = <WorkerCalculationMonthlySalary />;
      break;
    case '/WorkerMonthlySalary':
      routeComponent = <WorkerMonthlySalary />;
      break;
    case '/WorkerSelectionAssistant':
      routeComponent = <WorkerSelectionAssistant />;
      break;
    case '/ExpertTicket':
      routeComponent = <ExpertTicket />;
      break;
    case '/ExpertContentLikeReport':
      routeComponent = <ExpertContentLikeReport />;
      break;
    case '/ExpertContentViewReport':
      routeComponent = <ExpertContentViewReport />;
      break;
    case '/AdvancePaymentBlockWorker':
      routeComponent = <AdvancePaymentBlockWorker />;
      break;
    case '/InsuranceRule':
      routeComponent = <InsuranceRule />;
      break;
    case '/InsurancePremium':
      routeComponent = <InsurancePremium />;
      break;
    case '/InsurancePremiumReport':
      routeComponent = <InsurancePremiumReport />;
      break;
    case '/Obligation':
      routeComponent = <Obligation />;
      break;
    case '/ContractualOrderOperationReason':
      routeComponent = <ContractualOrderOperationReason />;
      break;
    case '/SaleFunnelStepActivity':
      routeComponent = <SaleFunnelStepActivity />;
      break;
    case '/Contract':
      routeComponent = <Contract />;
      break;
    case '/TimePrivacy':
      routeComponent = <TimePrivacy />;
      break;
    case '/ServicePoint':
      routeComponent = <ServicePoint />;
      break;
    case '/ContractOffer':
      routeComponent = <ContractOffer />;
      break;
    case '/ContractualOrderSchedule':
      routeComponent = <ContractualOrderSchedule />;
      break;
    case '/ContractualOrderScheduleCanceled':
      routeComponent = <ContractualOrderScheduleCanceled />;
      break;
    case '/ContractualOrderLead':
      routeComponent = <ContractualOrderLead />;
      break;
    case '/ContractualOrderScheduleSaleLead':
      routeComponent = <ContractualOrderScheduleSaleLead />;
      break;
    case '/ContractualOrderScheduleSaleOpportunity':
      routeComponent = <ContractualOrderScheduleSaleOpportunity />;
      break;
    case '/ContractualOrderScheduleSaleOpportunitySuccessful':
      routeComponent = <ContractualOrderScheduleSaleOpportunitySuccessful />;
      break;
    case '/ContractualOrderScheduleReport':
      routeComponent = <ContractualOrderScheduleReport />;
      break;
    case '/ContractualOrderScheduleRenewalReport':
      routeComponent = <ContractualOrderScheduleRenewalReport />;
      break;
    case '/ContractualOrderScheduleSaleFunnelStatusHistoryReport':
      routeComponent = (
        <ContractualOrderScheduleSaleFunnelStatusHistoryReport />
      );
      break;
    case '/TransportationMonitoring':
      routeComponent = <TransportationMonitoring />;
      break;
    case '/Snapp':
      routeComponent = <Snapp />;
      break;
    case '/OrderPerformanceReport':
      routeComponent = <OrderPerformanceReport />;
      break;
    case '/WorkCompletedMissionReport':
      routeComponent = <WorkCompletedMissionReport />;
      break;
    case '/MessageInApplication':
      routeComponent = <MessageInApplication />;
      break;
    case '/MarketingWorkerIntroducedReport':
      routeComponent = <MarketingWorkerIntroducedReport />;
      break;
    case '/CustomerIntroductionMissionReport':
      routeComponent = <CustomerIntroductionMissionReport />;
      break;
    case '/PointMissionReport':
      routeComponent = <PointMissionReport />;
      break;
    case '/SurveyMissionReport':
      routeComponent = <SurveyMissionReport />;
      break;
    case '/WorkerIntroductionMissionReport':
      routeComponent = <WorkerIntroductionMissionReport />;
      break;
    case '/FavoriteWorkerMissionReport':
      routeComponent = <FavoriteWorkerMissionReport />;
      break;
    case '/NDaysAfterStartMissionReport':
      routeComponent = <NDaysAfterStartMissionReport />;
      break;
    case '/RewardMissionReport':
      routeComponent = <RewardMissionReport />;
      break;
    case '/SpecialDaysMissionReport':
      routeComponent = <SpecialDaysMissionReport />;
      break;
    case '/SpecialOrderMissionReport':
      routeComponent = <SpecialOrderMissionReport />;
      break;
    case '/TransportationProvider':
      routeComponent = <TransportationProvider />;
      break;
    case '/JobDispatch':
      routeComponent = <JobDispatch />;
      break;
    case '/CardToCardTracking':
      routeComponent = <CardToCardTracking />;
      break;
    default:
      break;
  }
  return <Suspense fallback={<Loader />}>{routeComponent}</Suspense>;
}
